import { render } from "./PelSchoolConfirmation.vue?vue&type=template&id=86ba36a6&scoped=true&ts=true"
import script from "./PelSchoolConfirmation.vue?vue&type=script&lang=ts"
export * from "./PelSchoolConfirmation.vue?vue&type=script&lang=ts"

import "./PelSchoolConfirmation.vue?vue&type=style&index=0&id=86ba36a6&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ba36a6"]])

export default __exports__